module.exports = __webpack_public_path__ + "static/media/21ECLAC6.0c97ecb3.jpg";